import React, { useState, useEffect } from 'react';
import { FaUser, FaSignOutAlt, FaTimes, FaCog } from 'react-icons/fa';
import { getApiUrl } from '../../config/constants';
import { getTranslation } from '../../utils/translations';
import './UserProfile.css';

const UserProfile = ({ isOpen, onClose, language = 'ar' }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (err) {
        console.error('Error parsing user data:', err);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
    }
  }, [isOpen]);

  // Check if user has admin access
  const hasAdminAccess = () => {
    if (!user) return false;
    return user.role === 'admin' ||
           user.role === 'project_manager' ||
           user.account_type === 'developer';
  };

  const handleAdminPanelAccess = () => {
    // Get the backend URL from API config and construct admin URL
    const backendUrl = getApiUrl('').replace('/api', '');
    const adminUrl = `${backendUrl}/admin`;

    // Open admin panel in new tab
    window.open(adminUrl, '_blank');
  };

  const handleLogout = async () => {
    setIsLoading(true);

    try {
      const token = localStorage.getItem('token');
      if (token) {
        await fetch(getApiUrl('/auth/logout'), {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json',
          },
        });
      }
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      // Clear local storage regardless of API call result
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      setUser(null);
      setIsLoading(false);

      // Dispatch custom event to notify other components
      window.dispatchEvent(new Event('authStatusChanged'));

      // Close the profile modal
      onClose();

      // Optionally reload the page to reset app state
      window.location.reload();
    }
  };

  if (!isOpen || !user) {
    return null;
  }

  return (
    <div className="user-profile-overlay" onClick={onClose}>
      <div 
        className={`user-profile-modal ${language === 'ar' ? 'rtl' : 'ltr'}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="profile-header">
          <h3 className="profile-title">
            {language === 'ar' ? 'الملف الشخصي' : 'Profile'}
          </h3>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="profile-content">
          <div className="user-info-section">
            <div className="user-avatar">
              <img src="/user white v2.png" alt="User Avatar" className="avatar-icon" />
            </div>
            <div className="user-details">
              <h4 className="user-name">{user.name}</h4>
              <p className="user-email">{user.email}</p>
            </div>
          </div>

          <div className="profile-actions">
            {hasAdminAccess() && (
              <button
                className="admin-panel-btn"
                onClick={handleAdminPanelAccess}
                disabled={isLoading}
              >
                <FaCog className="admin-icon" />
                <span>{getTranslation('adminPanel', language)}</span>
              </button>
            )}

            <button
              className="logout-btn"
              onClick={handleLogout}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="loading-spinner"></div>
              ) : (
                <>
                  <FaSignOutAlt className="logout-icon" />
                  <span>{language === 'ar' ? 'تسجيل الخروج' : 'Logout'}</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
